import styled from 'styled-components';
import { GradientText } from 'src/common';
import MaterialInput from '../../MaterialInput';
import { InputAdornment } from '@mui/material';

export const Menux = styled.div`
  position: absolute;
  transform: translate(0px, 4px);
  right: 0;
  z-index: 10000000;

  .ms-options {
    right: 0;
    padding-top: 12px;
    min-width: 270px;
    background-color: ${({ theme }) => theme.colors.white};
    border: 1px solid ${({ theme }) => theme.colors.stroke};
    border-radius: 3px;

    cursor: default;
    display: grid;
    grid-gap: 10px;
    user-select: none;
    box-shadow: 0px 0px 37px ${({ theme }) => theme.colors.shadow};
    z-index: 100;
    max-height: 300px;
    overflow-y: auto;

    &__title {
      font-size: 14px;
      color: ${({ theme }) => theme.colors.cflowerBlue};
      margin: 0 20px;
      margin-bottom: 4px;
    }

    &__item {
      padding: 0 20px;
      display: flex;
      grid-gap: 10px;
      cursor: pointer;
      overflow: hidden;
      align-items: center;

      &--creatable {
        cursor: default;
        justify-content: space-between;

        .msc-delete {
          position: relative;
          z-index: 1;
          color: ${({ theme }) => theme.colors.cflowerBlue};
          font-size: 14px;
          cursor: pointer;
          &::before {
            content: '';
            position: absolute;
            width: 25px;
            height: 25px;
            z-index: -1;
            left: -10px;
          }
          &:hover {
            color: ${({ theme }) => theme.colors.gp1};
          }
        }
      }

      &__title {
        font-weight: 500;
        font-size: 14px;
      }
    }

    &__clear {
      height: 40px;
      display: flex;
      justify-content: center;
      align-items: center;
      user-select: none;
      border-top: 1px solid ${({ theme }) => theme.colors.stroke};
      background-color: ${({ theme }) => theme.colors.cultured};
      margin-top: 4px;
      span {
        font-size: 14px;
        color: ${({ theme }) => theme.colors.cflowerBlue};
      }

      &:hover {
        cursor: pointer;
        background: ${({ theme }) => theme.colors.gradient};
        span {
          color: ${({ theme }) => theme.colors.white};
        }
      }
    }
  }

  .divider {
    border-top: 1px solid ${({ theme }) => theme.colors.stroke};
    margin: 10px 0;
    margin: 0 20px;
  }

  .cinput {
    display: none;
    input {
      padding: 0 !important;
    }
  }
`;

export const StyledInputAdornment = styled(InputAdornment)`
  cursor: pointer;
  margin-right: 22px;
  &:hover {
    svg {
      opacity: 0.6;
    }
  }
  svg {
    fill: #565863;
    transition: opacity 0.3s;
  }
`;

export const ArrowSvg = styled.svg<{ $isOpen?: boolean }>`
  transform: ${({ $isOpen }) => ($isOpen ? 'rotate(180deg)' : 'rotate(0deg)')};
`;

export const AddOptionText = styled(GradientText)`
  text-transform: none;
  font-weight: 500;
  max-width: 88%;
`;

export const StyledInput = styled(MaterialInput)`
  .MuiInputBase-root {
    background-color: ${({ theme }) => theme.colors.cultured};
  }

  input,
  textarea {
    padding: 16px 20px;
  }
`;

export const RelativeWrap = styled.div`
  position: relative;
`;

export const AddOptionIcon = styled.svg`
  margin-left: auto;
  cursor: pointer;
`;
